<!-- eslint-disable max-len -->
<template>
  <div>
    <div v-if="currentUserHasTeamAndPlan" class="my-team__expiry-info">
      <span class="font-bold">Licenses used:</span>
      <span>
        {{ account.numberOfUsedLicenses | formatNumber }}/{{ account.licenseQuantity | formatNumber }} -
      </span>
      <span class="font-bold">Expires:</span>
      <span v-if="account.planEndAt"> {{ account.planEndAt | dateTimeStamp }}</span>
    </div>
    <div v-if="currentUserHasTeamAndExpiredPlan" class="my-team__expiry-info ">
      <span class="font-bold">Your licences have expired</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    account: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    currentUserHasTeamAndPlan() {
      return this.$store.state.currentUser.accountId && this.$store.state.currentUser.plan !== 'free'
    },
    currentUserHasTeamAndExpiredPlan() {
      return this.$store.state.currentUser.accountId && this.$store.state.currentUser.plan === 'free'
    },
  },
}
</script>
